import React, { Suspense, lazy, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams, Navigate } from 'react-router-dom';

import Loading from '@components/Loading/Loading';
import { Permission } from '@models/permission';
import { newMenuMap } from '@store/reducers/permissionSlice';
import { theme } from 'antd';

import './DashboardContentLayout.scss';

const { useToken } = theme;

function DashboardContentLayout() {
  const { token } = useToken();
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const { levelOne, levelTwo, levelThree } = useParams();
  const menuMap = useSelector(newMenuMap);
  console.log('DashboardContentLayout menuMap:', menuMap);

  function hasPermission(menuItems: Permission[]): boolean {
    const path = `${levelOne}/${levelTwo}/${levelThree}`;

    // newMenuMap 是從 permissionSlice 整理過的菜單，只有第三級才有 path，其他級 path 都是 undefined
    // 比對成功代表他有這個權限可以進入此 path
    return menuItems.some((item: Permission) => {
      if (item.type === 'THIRD_LEVEL_MENU' && item.path === path) {
        return true;
      }
      if (item.children) {
        return hasPermission(item.children);
      }

      return false;
    });
  }

  useEffect(() => {
    // 沒有權限或是沒有任一級的 path 就直接轉導到 /home
    if (!hasPermission(menuMap) || !levelOne || !levelTwo || !levelThree) {
      setShouldRedirect(true);
    } else {
      // 嘗試動態導入元件
      import(`@pages/${levelOne}/${levelTwo}/${levelThree}/${levelThree}`)
        .then(() => {
          console.log(
            `Successfully imported /${levelOne}/${levelTwo}/${levelThree}/${levelThree}`,
          );
        })
        .catch(() => {
          // 如果專案內找不到此檔案，就直接轉導到 /home
          console.log('import Failed');
          setShouldRedirect(true);
        });
    }
  }, [levelOne, levelTwo, levelThree, menuMap]);

  if (shouldRedirect) {
    return <Navigate to="/home" replace />;
  }

  // 經歷過上面的判斷，代表專案內有此檔案，就動態導入 Component
  const TargetComponent = lazy(
    () => import(`@pages/${levelOne}/${levelTwo}/${levelThree}/${levelThree}`),
  );

  return (
    <div className="DashboardContentLayout">
      <Suspense fallback={<Loading spinBGColor={token.colorBgLayout} />}>
        <TargetComponent />
      </Suspense>
    </div>
  );
}

export default DashboardContentLayout;
